module.exports = __webpack_public_path__ + "img/one-page-plan.c6fa5c5f.svg";